export const solidsmoke = [
	{
		"id": 1,
		"jump": "solid1",
		"title": "Solid Smoke I",
		"pic": "../img/solidsmoke/solid-smoke-1.jpg",
		"alt": "Solid Smoke 1, Digital Art Series",
		"left": "imagewider shadow ",
		"right": "slimmer",
		"orientation": "landscape"
	},
	{
		"id": 2,
		"jump": "solid2",
		"title": "Solid Smoke II",
		"pic": "../img/solidsmoke/solid-smoke-2.jpg",
		"alt": "Solid Smoke 2, Digital Art Series",
		"left": "imagewide",
		"right": "slim",
		"orientation": "work"
	},
]